var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LUI-icon-pd-information-solid-16",
    transform: "translate(-1.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37,1.1 C6.34593919,0.498528576 3.28443775,1.9465571 1.83100462,4.66579299 C0.377571492,7.38502887 0.874513906,10.7350477 3.05473312,12.9152669 C5.23495234,15.0954861 8.58497113,15.5924285 11.304207,14.1389954 C14.0234429,12.6855622 15.4714714,9.62406081 14.87,6.6 C14.3176826,3.82307445 12.1469255,1.65231739 9.37,1.1 Z M9,6 L9,10 L10,10 L10,12 L6,12 L6,10 L7,10 L7,8 L6,8 L6,6 L9,6 Z M9.00429899,2.96504574 L9.00429899,4.96504574 L7.00429899,4.96504574 L7.00429899,2.96504574 L9.00429899,2.96504574 Z",
    id: "---\\u21B3-\\uD83C\\uDF08-Color",
    fill: "#38e5e2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGreen);
export default __webpack_public_path__ + "static/media/info-green.ef25275a2009d4c58c23d91445f459d9.svg";
export { ForwardRef as ReactComponent };